import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.jsx";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim.jsx";
import SectionTitle from "../../components/SectionTitle/SectionTitle.jsx";
import './GetPDFPage.css'

const GetPDFPage = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [fileSize, setFileSize] = useState(null);

    useEffect(() => {
      const fetchPDF = async () => {
        const baseUrl =
          process.env.REACT_APP_ENV === "local"
            ? "http://dev-cluster1.onb.ac.at:30518"
            : "";
        const pdfApiUrl = `${baseUrl}/api/order/${orderId}`;

        try {
          const response = await fetch(pdfApiUrl);

          if (response.status === 202) {
            navigate("/error", {
              state: {
                status: 202,
                message: "Leider steht Ihr Download noch nicht zur Verfügung. Bitte haben Sie noch etwas Geduld.",
              },
            });
            return;
          }

          if (response.ok) {
            setPdfUrl(pdfApiUrl);
            const contentLength = response.headers.get("Content-Length");
            if (contentLength) {
              const sizeInBytes = parseInt(contentLength, 10);
              const fileSize =
                sizeInBytes >= 1024 * 1024
                  ? `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`
                  : `${Math.round(sizeInBytes / 1024)} KB`;
              setFileSize(fileSize);
            }
          } else {
            let errorMessage;
            let buttonText;
            let buttonLink;
            let hasSecondaryHintLine;
            let isPdf404Error;
            switch (response.status) {
              case 400:
                errorMessage = "Leider ist dieser Link ungültig.";
                    break;
              case 404:
                errorMessage = "Der aufgerufene Link ist ungültig.";
                hasSecondaryHintLine = true;
                isPdf404Error = true;
                break;
              case 410:
                errorMessage =
                  "Leider ist die Gültigkeit Ihres Download-Links abgelaufen. Aus technischen Gründen können wir PDF-Bestellungen nur 14 Tage zur Verfügung stellen. Bitte bestellen Sie die von Ihnen gewünschte PDF-Datei erneut. Wir bitten um Ihr Verständnis.";
                break;
              case 422:
                errorMessage = "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder. Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an digital@onb.ac.at"
                hasSecondaryHintLine = true;
                buttonText = "Zurück zum Objekt";
                buttonLink = "https://viewer.onb.ac.at/" + orderId;
                break;
              case 500:
                errorMessage =
                  "Leider ist ein Problem aufgetreten, bitte probieren Sie es zu einem späteren Zeitpunkt wieder.";
                hasSecondaryHintLine = true;
                buttonText = "Zurück zum Objekt";
                buttonLink = "https://viewer.onb.ac.at/" + orderId;
                break;
              default:
                errorMessage = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
            }
            const responseBodyText = await response.text();
            let responseBody;
            try {
              responseBody = JSON.parse(responseBodyText);
            } catch {
              responseBody = null;
            }
            const astorId = responseBody?.astorId || null;
            navigate("/error", { state: { status: response.status, message: errorMessage, astorId, buttonText, buttonLink, hasSecondaryHintLine, isPdf404Error } });
          }
        } catch (error) {
          navigate("/error", {
            state: { message: "Netzwerkfehler. Bitte versuchen Sie es später erneut.", status: 500 },
          });
        } finally {
          setLoading(false);
        }
      };

      if (orderId) fetchPDF();
    }, [orderId, navigate]);

    return (
      <>
        <PageTitleSlim title="PDF Download" />
        <section className="container narrow">
          <SectionTitle title="Ihr Dokument steht bereit" />
          <div className="section-inner">
            <div className="form-container">
              {loading ? (
                <>
                  <LoadingSpinner />
                </>
              ) : pdfUrl ? (
                <>
                  {fileSize && <h3>Dateigröße: {fileSize}</h3>}
                  <h3>Klicken Sie hier, um den Download zu starten:</h3>
                  <button className="button primary hollow">
                    <a
                      href={pdfUrl}
                      download
                      className="download-link"
                    >
                      Herunterladen
                    </a>
                  </button>
                </>
              ) : (
                <h3>Es ist ein Problem aufgetreten. Bitte versuchen Sie es später erneut.</h3>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };

  export default GetPDFPage;
